export default __webpack_public_path__ + "static/media/APY Light mode.c3a4fa4c.png";